export default {
  EDIT_EMERGENCY_FUND_GOAL_PLAN_STATE_MANAGER: Symbol.for('EDIT_EMERGENCY_FUND_GOAL_PLAN_STATE_MANAGER'),
  EDIT_EMERGENCY_FUND_GOAL_PLAN_BUDGET_SERVICE: Symbol.for('EDIT_EMERGENCY_FUND_GOAL_PLAN_BUDGET_SERVICE'),
  EDIT_EMERGENCY_FUND_GOAL_PLAN_CURRENT_AMOUNT_SERVICE: Symbol.for('EDIT_EMERGENCY_FUND_GOAL_PLAN_CURRENT_AMOUNT_SERVICE'),
  EDIT_EMERGENCY_FUND_GOAL_PLAN_CURRENT_PLAN_SERVICE: Symbol.for('EDIT_EMERGENCY_FUND_GOAL_PLAN_CURRENT_PLAN_SERVICE'),
  EDIT_EMERGENCY_FUND_GOAL_PLAN_DEFINE_BY_SERVICE: Symbol.for('EDIT_EMERGENCY_FUND_GOAL_PLAN_DEFINE_BY_SERVICE'),
};
